import { combineReducers } from 'redux';
import channel from './epg.channel.reducer';
import event from './event.reducer';
import favoriteChannels from './favorite.reducer';
import channelCategories from './categories.reducer';
import channelBlocker from './channelBlocker.reducer';

export default combineReducers({
  channel,
  event,
  favoriteChannels,
  channelCategories,
  channelBlocker,
});
